/**
 * The single permission table (master 3.2). Policy guards, service scoping and the
 * generated permission matrix test all read this data.
 */
export const ROLES = ['owner', 'branch_manager', 'agent', 'accounts'];
/**
 * How far a role's capability reaches.
 * none: not allowed. own: records the member owns. branch: records in the member's branch.
 * all: every branch in the agency.
 */
export const SCOPES = ['none', 'own', 'branch', 'all'];
const row = (owner, branchManager, agent, accounts) => ({
    owner,
    branch_manager: branchManager,
    agent,
    accounts,
});
export const PERMISSIONS = {
    'branches.view': row('all', 'branch', 'branch', 'all'),
    /** Founder decision 2026-10-16: every member reads every property of the agency. */
    'properties.read': row('all', 'all', 'all', 'all'),
    /** Owner edits all, a manager their branch, an agent only their own listings. */
    'properties.write': row('all', 'branch', 'own', 'none'),
    'visits.read': row('all', 'branch', 'own', 'none'),
    'visits.assign': row('all', 'branch', 'none', 'none'),
    /** Confirm, reschedule, mark done or no show, cancel. */
    'visits.update': row('all', 'branch', 'own', 'none'),
    'deals.run': row('all', 'branch', 'own', 'none'),
    'clients.phone_read': row('all', 'branch', 'own', 'none'),
    'passbook.read': row('all', 'branch', 'own', 'all'),
    'brokerage.record': row('all', 'branch', 'none', 'all'),
    'renewals.read': row('all', 'branch', 'own', 'none'),
    'records.reassign': row('all', 'branch', 'none', 'none'),
    /** Registration partners belong to the agency, not a branch, so a manager reaches all of them. */
    'partners.manage': row('all', 'all', 'none', 'none'),
    'branches.manage': row('all', 'none', 'none', 'none'),
    'members.manage': row('all', 'branch', 'none', 'none'),
    'brand.manage': row('all', 'none', 'none', 'none'),
    'billing.view': row('all', 'none', 'none', 'all'),
    'billing.manage': row('all', 'none', 'none', 'none'),
    /** Own notices and preferences. Accounts see only money notices (billing and brokerage). */
    'notifications.own': row('all', 'own', 'own', 'own'),
    'export.csv': row('all', 'branch', 'own', 'all'),
};
export const CAPABILITIES = Object.keys(PERMISSIONS);
export function scopeFor(role, capability) {
    return PERMISSIONS[capability][role];
}
export function can(role, capability) {
    return scopeFor(role, capability) !== 'none';
}
//# sourceMappingURL=permissions.js.map